import {Image} from 'quickstart/components/content/Image'
import {FCx} from 'quickstart/types'
import * as S from './styles'

interface FakeCoverProps {
  src: string
  alt?: string
  title?: string
  // TODO These are for S.FakeCover which needs to be converted
  tizraId: string
  aspectRatio?: number | string
  hoverable?: boolean
  bordered?: boolean
  shadowed?: boolean
}

export const FakeCover: FCx<FakeCoverProps> = ({
  src,
  alt = '',
  title = '',
  bordered,
  shadowed,
  hoverable,
  ...props
}) => {
  return (
    <S.FakeCover {...props} {...(!src && {bordered, shadowed, hoverable})}>
      {src ?
        <Image
          alt={alt}
          src={src}
          bordered={bordered}
          shadowed={shadowed}
          hoverable={hoverable}
          style={{
            width: '100%',
            height: props.aspectRatio ? '100%' : 'auto',
            objectFit: 'cover',
          }}
        />
      : title}
    </S.FakeCover>
  )
}

FakeCover.displayName = 'FakeCover'
